// @flow
import getImportsFrom from 'app/common/lib/ReactRouter/getImports';

const getImport = getImportsFrom('app/www/bundleLoaders');

export const ActivityFeed = getImport({
  loader: () =>
    import(/* webpackChunkName: "ActivityFeedPageDesktop" */ 'app/www/pages/ActivityFeedPage'),
  name: 'ActivityFeedPageDesktop',
  path: 'app/www/pages/ActivityFeedPage',
});
export const Article = getImport({
  loader: () => import(/* webpackChunkName: "ArticlePageDesktop" */ 'app/www/pages/ArticlePage'),
  name: 'ArticlePageDesktop',
  path: 'app/www/pages/ArticlePage',
});
export const ArticleProductsFeed = getImport({
  loader: () =>
    import(/* webpackChunkName: "ArticleProductsPageDesktop" */ 'app/www/pages/ArticleProductsPage'),
  name: 'ArticleProductsPageDesktop',
  path: 'app/www/pages/ArticleProductsPage',
});
export const Board = getImport({
  loader: () => import(/* webpackChunkName: "BoardPageDesktop" */ 'app/www/pages/BoardPage'),
  name: 'BoardPageDesktop',
  path: 'app/www/pages/BoardPage',
});
export const BoardPageContainer = getImport({
  loader: () =>
    import(/* webpackChunkName: "BoardPageContainerDesktop" */ 'app/www/pages/BoardPageContainer'),
  name: 'BoardPageContainer',
  path: 'app/www/pages/BoardPageContainer',
});
export const BoardDiscoveryCardFeed = getImport({
  loader: () =>
    import(/* webpackChunkName: "BoardIdeasCardFeedPageDesktop" */ 'app/www/pages/BoardIdeasCardFeedPage'),
  name: 'BoardIdeasCardFeedPageDesktop',
  path: 'app/www/pages/BoardIdeasCardFeedPage',
});
export const BoardActivityComment = getImport({
  loader: () =>
    import(/* webpackChunkName: "BoardActivityCommentPageDesktop" */ 'app/www/pages/BoardActivityCommentPage'),
  name: 'BoardActivityCommentPageDesktop',
  path: 'app/www/pages/BoardActivityItemPage',
});
export const BoardActivityItem = getImport({
  loader: () =>
    import(/* webpackChunkName: "BoardActivityItemPageDesktop" */ 'app/www/pages/BoardActivityItemPage'),
  name: 'BoardActivityItemPageDesktop',
  path: 'app/www/pages/BoardActivityItemPage',
});
export const BoardSection = getImport({
  loader: () =>
    import(/* webpackChunkName: "BoardSectionPageDesktop" */ 'app/www/pages/BoardSectionPage'),
  name: 'BoardSectionPageDesktop',
  path: 'app/www/pages/BoardSectionPage',
});
export const BusinessAccountLogin = getImport({
  loader: () =>
    import(/* webpackChunkName: "BusinessAccountLoginPageDesktop" */ 'app/www/pages/BusinessAccountLoginPage'),
  name: 'BusinessAccountLoginPageDesktop',
  path: 'app/www/pages/BusinessAccountLoginPage',
});
export const BusinessAccountConvert = getImport({
  loader: () =>
    import(/* webpackChunkName: "BusinessAccountConvertPageDesktop" */ 'app/www/pages/BusinessAccountConvertPage'),
  name: 'BusinessAccountConvertPageDesktop',
  path: 'app/www/pages/BusinessAccountConvertPage',
});
export const BusinessAccountCreate = getImport({
  loader: () =>
    import(/* webpackChunkName: "BusinessAccountCreatePageDesktop" */ 'app/www/pages/BusinessAccountCreatePage'),
  name: 'BusinessAccountCreatePageDesktop',
  path: 'app/www/pages/BusinessAccountCreatePage',
});
export const BusinessAccountSwitcher = getImport({
  loader: () =>
    import(/* webpackChunkName: "BusinessAccountSwitcherPageDesktop" */ 'app/www/pages/BusinessAccountSwitcherPage'),
  name: 'BusinessAccountSwitcherPageDesktop',
  path: 'app/www/pages/BusinessAccountSwitcherPage',
});
export const Categories = getImport({
  loader: () =>
    import(/* webpackChunkName: "CategoriesPageDesktop" */ 'app/common/react/components/Categories/CategoriesPage/CategoriesPage'),
  name: 'CategoriesPageDesktop',
  path: 'app/common/react/components/Categories/CategoriesPage/CategoriesPage',
});
export const Category = getImport({
  loader: () => import(/* webpackChunkName: "CategoryPageDesktop" */ 'app/www/pages/CategoryPage'),
  name: 'CategoryPageDesktop',
  path: 'app/www/pages/CategoryPage',
});
export const Closeup = getImport({
  loader: () => import(/* webpackChunkName: "CloseupPageDesktop" */ 'app/www/pages/CloseupPage'),
  name: 'CloseupPageDesktop',
  path: 'app/www/pages/CloseupPage',
});
export const CloseupPromote = getImport({
  loader: () =>
    import(/* webpackChunkName: "CloseupPromotePageDesktop" */ 'app/www/pages/CloseupPromotePage'),
  name: 'CloseupPromotePageDesktop',
  path: 'app/www/pages/CloseupPromotePage',
});
export const CreativeEditorPage = getImport({
  loader: () =>
    import(/* webpackChunkName: "CreativeEditorPageDesktop" */ 'app/www/pages/CreativeEditorPage'),
  name: 'CreativeEditorPageDesktop',
  path: 'app/www/pages/CreativeEditorPage',
});
export const CsrfError = getImport({
  loader: () =>
    import(/* webpackChunkName: "CsrfErrorPageDesktop" */ 'app/www/pages/CsrfErrorPage/CsrfErrorPage'),
  name: 'CsrfErrorPageDesktop',
  path: 'app/www/pages/CsrfErrorPage/CsrfErrorPage',
});
export const DomainFeed = getImport({
  loader: () =>
    import(/* webpackChunkName: "DomainFeedPageDesktop" */ 'app/common/react/components/MiscFeedPages/DomainFeedPage'),
  name: 'DomainFeedPageDesktop',
  path: 'app/common/react/components/MiscFeedPages/DomainFeedPage',
});
export const DomainVerify = getImport({
  loader: () =>
    import(/* webpackChunkName: "DomainVerifyDesktop" */ 'app/www/pages/DomainVerifyPage'),
  name: 'DomainVerifyPageDesktop',
  path: 'app/www/pages/DomainVerifyPage',
});
export const EmailDisassociatePage = getImport({
  loader: () =>
    import(/* webpackChunkName: "EmailDisassociatePageDesktop" */ 'app/www/pages/EmailDisassociatePage'),
  name: 'EmailDisassociatePageDesktop',
  path: 'app/www/pages/EmailDisassociatePage',
});
export const EmailUnsubscribePage = getImport({
  loader: () =>
    import(/* webpackChunkName: "EmailUnsubscribePageDesktop" */ 'app/www/pages/EmailUnsubscribePage'),
  name: 'EmailUnsubscribePageDesktop',
  path: 'app/www/pages/EmailUnsubscribePage',
});
export const EmailVerificationError = getImport({
  loader: () =>
    import(/* webpackChunkName: "EmailVerificationErrorPageDesktop" */ 'app/www/pages/EmailVerificationErrorPage'),
  name: 'EmailVerificationErrorPageDesktop',
  path: 'app/www/pages/EmailVerificationErrorPage',
});
export const Error404 = getImport({
  loader: () => import(/* webpackChunkName: "Error404PageDesktop" */ 'app/www/pages/Error404Page'),
  name: 'Error404PageDesktop',
  path: 'app/www/pages/Error404Page',
});
export const Explore = getImport({
  loader: () => import(/* webpackChunkName: "ExplorePageDesktop" */ 'app/www/pages/ExplorePage'),
  name: 'ExplorePageDesktop',
  path: 'app/www/pages/ExplorePage',
});
export const ExplorePossibilitiesFeed = getImport({
  loader: () =>
    import(/* webpackChunkName: "ExplorePossibilitiesFeed" */ 'app/www/pages/ExplorePossibilitiesFeedPage'),
  name: 'ExplorePossibilitiesFeedDesktop',
  path: 'app/www/pages/ExplorePossibilitiesFeedPage',
});
export const FirstAdCreate = getImport({
  loader: () =>
    import(/* webpackChunkName: "FirstAdCreatePageDesktop" */ 'app/www/pages/FirstAdCreatePage'),
  name: 'FirstAdCreatePageDesktop',
  path: 'app/www/pages/FirstAdCreatePage',
});
export const Flashlight = getImport({
  loader: () =>
    import(/* webpackChunkName: "FlashlightPageDesktop" */ 'app/www/pages/FlashlightPage'),
  name: 'FlashlightPageDesktop',
  path: 'app/www/pages/FlashlightPage',
});
export const Followers = getImport({
  loader: () =>
    import(/* webpackChunkName: "FollowersPageDesktop" */ 'app/www/pages/FollowersPage'),
  name: 'FollowersPageDesktop',
  path: 'app/www/pages/FollowersPage',
});
export const Following = getImport({
  loader: () =>
    import(/* webpackChunkName: "FollowingPageDesktop" */ 'app/www/pages/FollowingPage'),
  name: 'FollowingPageDesktop',
  path: 'app/www/pages/FollowingPage',
});
export const FollowingFeed = getImport({
  loader: () =>
    import(/* webpackChunkName: "FollowingFeedPageDesktop" */ 'app/www/pages/FollowingFeedPage'),
  name: 'FollowingFeedPageDesktop',
  path: 'app/www/pages/FollowingFeedPage',
});
export const FollowingFeedBuild = getImport({
  loader: () =>
    import(/* webpackChunkName: "FollowingFeedBuildPageDesktop" */ 'app/www/pages/FollowingFeedBuildPage'),
  name: 'FollowingFeedBuildPageDesktop',
  path: 'app/www/pages/FollowingFeedBuildPage',
});
export const FollowingFeedManage = getImport({
  loader: () =>
    import(/* webpackChunkName: "FollowingFeedManagePageDesktop" */ 'app/www/pages/FollowingFeedManagePage'),
  name: 'FollowingFeedManagePageDesktop',
  path: 'app/www/pages/FollowingFeedManagePage',
});
export const Home = getImport({
  loader: () => import(/* webpackChunkName: "AuthHomePageDesktop" */ 'app/www/pages/AuthHomePage'),
  name: 'AuthHomePageDesktop',
  path: 'app/www/pages/AuthHomePage',
});
export const ImagesFeed = getImport({
  loader: () =>
    import(/* webpackChunkName: "ImagesFeedPageDesktop" */ 'app/www/pages/ImagesFeedPage'),
  name: 'ImagesFeedPageDesktop',
  path: 'app/www/pages/ImagesFeedPage',
});
export const InterestFeed = getImport({
  loader: () =>
    import(/* webpackChunkName: "InterestFeedPageDesktop" */ 'app/www/pages/InterestFeedPage'),
  name: 'InterestFeedPageDesktop',
  path: 'app/www/pages/InterestFeedPage',
});
export const Invited = getImport({
  loader: () => import(/* webpackChunkName: "InvitedPageDesktop" */ 'app/www/pages/InvitedPage'),
  name: 'InvitedPageDesktop',
  path: 'app/www/pages/InvitedPage',
});
export const Login = getImport({
  loader: () => import(/* webpackChunkName: "LoginPageDesktop" */ 'app/www/pages/LoginPage'),
  name: 'LoginPageDesktop',
  path: 'app/www/pages/LoginPage',
});
export const Logout = getImport({
  loader: () => import(/* webpackChunkName: "LogoutPageDesktop" */ 'app/www/pages/LogoutPage'),
  name: 'LogoutPageDesktop',
  path: 'app/www/pages/LogoutPage',
});
export const Catalogs = getImport({
  loader: () => import(/* webpackChunkName: "CatalogsPageDesktop" */ 'app/www/pages/CatalogsPage'),
  name: 'CatalogsPageDesktop',
  path: 'app/www/pages/CatalogsPage',
});
export const CatalogsProductGroupEditor = getImport({
  loader: () =>
    import(/* webpackChunkName: "CatalogsProductGroupEditorPageDesktop" */ 'app/www/pages/CatalogsProductGroupEditorPage'),
  name: 'CatalogsProductGroupEditorPageDesktop',
  path: 'app/www/pages/CatalogsProductGroupEditorPage',
});
export const MobileLandingPage = getImport({
  loader: () =>
    import(/* webpackChunkName: "MobileLandingPageDesktop" */ 'app/www/pages/MobileLandingPage'),
  name: 'MobileLandingPageDesktop',
  path: 'app/www/pages/MobileLandingPage',
});
export const NewsHubLanding = getImport({
  loader: () =>
    import(/* webpackChunkName: "NewsHubLandingPageDesktop" */ 'app/common/react/components/growth/news/NewsHub/NewsHubLandingPage'),
  name: 'NewsHubLandingPageDesktop',
  path: 'app/common/react/components/growth/news/NewsHub/NewsHubLandingPage',
});
export const OrderHistory = getImport({
  loader: () =>
    import(/* webpackChunkName: "OrderHistoryPageDesktop" */ 'app/www/pages/OrderHistoryPage'),
  name: 'OrderHistoryPageDesktop',
  path: 'app/www/pages/OrderHistoryPage',
});
export const PasswordReset = getImport({
  loader: () =>
    import(/* webpackChunkName: "PasswordResetPageDesktop" */ 'app/www/pages/PasswordResetPage'),
  name: 'PasswordResetPageDesktop',
  path: 'app/www/pages/PasswordResetPage',
});
export const PinBookmarklet = getImport({
  loader: () =>
    import(/* webpackChunkName: "PinBookmarkletPageDesktop" */ 'app/www/pages/PinBookmarkletPage'),
  name: 'PinBookmarkletPageDesktop',
  path: 'app/www/pages/PinBookmarkletPage',
});
export const PinToBoard = getImport({
  loader: () =>
    import(/* webpackChunkName: "PinToBoardPageDesktop" */ 'app/www/pages/PinToBoardPage'),
  name: 'PinToBoardPageDesktop',
  path: 'app/www/pages/PinToBoardPage',
});
export const PasswordUserNamePage = getImport({
  loader: () =>
    import(/* webpackChunkName: "PasswordUsernamePage" */ 'app/www/pages/PasswordUsernamePage'),
  name: 'PasswordUsernamePage',
  path: 'app/www/pages/PasswordUsernamePage',
});
export const PinBuilderPage = getImport({
  loader: () =>
    import(/* webpackChunkName: "PinBuilderPageDesktop" */ 'app/www/pages/PinBuilderPage'),
  name: 'PinBuilderPageDesktop',
  path: 'app/www/pages/PinBuilderPage',
});
export const PinCollagePage = getImport({
  loader: () =>
    import(/* webpackChunkName: "PinCollagePageDesktop" */ 'app/www/pages/PinCollagePage'),
  name: 'PinCollagePageDesktop',
  path: 'app/www/pages/PinCollagePage',
});
export const PinFeedbackPage = getImport({
  loader: () =>
    import(/* webpackChunkName: "PinFeedbackPageDesktop" */ 'app/www/pages/PinFeedbackPage'),
  name: 'PinFeedbackPageDesktop',
  path: 'app/www/pages/PinFeedbackPage',
});
export const PinLandingPage = getImport({
  loader: () =>
    import(/* webpackChunkName: "PinLandingPageDesktop" */ 'app/www/pages/PinLandingPage'),
  name: 'PinLandingPageDesktop',
  path: 'app/www/pages/PinLandingPage',
});
export const Profile = getImport({
  loader: () => import(/* webpackChunkName: "ProfilePageDesktop" */ 'app/www/pages/ProfilePage'),
  name: 'ProfilePageDesktop',
  path: 'app/www/pages/ProfilePage',
});
export const ProfileDecider = getImport({
  loader: () =>
    import(/* webpackChunkName: "ProfileDeciderContainerDesktop" */ 'app/common/react/components/profile/ProfileDecider/ProfileDeciderContainer'),
  name: 'ProfileDeciderContainerDesktop',
  path: 'app/common/react/components/profile/ProfileDecider/ProfileDeciderContainer',
});
export const RecipeFeed = getImport({
  loader: () =>
    import(/* webpackChunkName: "RecipeFeedPageDesktop" */ 'app/www/pages/RecipeFeedPage'),
  name: 'RecipeFeedPageDesktop',
  path: 'app/www/pages/RecipeFeedPage',
});
export const RelatedProductsFeed = getImport({
  loader: () =>
    import(/* webpackChunkName: "RelatedProductsPageDesktop" */ 'app/www/pages/RelatedProductsPage'),
  name: 'RelatedProductsPageDesktop',
  path: 'app/www/pages/RelatedProductsPage',
});
export const ScheduledPinFeedPage = getImport({
  loader: () =>
    import(/* webpackChunkName: "ScheduledPinFeedPageDesktop" */ 'app/www/pages/ScheduledPinFeedPage'),
  name: 'ScheduledPinFeedPageDesktop',
  path: 'app/www/pages/ScheduledPinFeedPage',
});
export const ScheduledPinCloseupPage = getImport({
  loader: () =>
    import(/* webpackChunkName: "ScheduledPinCloseupPageDesktop" */ 'app/www/pages/ScheduledPinCloseupPage'),
  name: 'ScheduledPinCloseupPageDesktop',
  path: 'app/www/pages/ScheduledPinCloseupPage',
});
export const Search = getImport({
  loader: () => import(/* webpackChunkName: "SearchPageDesktop" */ 'app/www/pages/SearchPage'),
  name: 'SearchPageDesktop',
  path: 'app/www/pages/SearchPage',
});
export const ShopTheLook = getImport({
  loader: () =>
    import(/* webpackChunkName: "ShopTheLookPageDesktop" */ 'app/www/pages/ShopTheLookPage'),
  name: 'ShopTheLookPageDesktop',
  path: 'app/www/pages/ShopTheLookPage',
});
export const ShowcaseSettings = getImport({
  loader: () =>
    import(/* webpackChunkName: "ShowcaseSettingsPageDesktop" */ 'app/www/pages/ShowcaseSettingsPage'),
  name: 'ShowcaseSettingsPageDesktop',
  path: 'app/www/pages/ShowcaseSettingsPage',
});
export const HomefeedControl = getImport({
  loader: () =>
    import(/* webpackChunkName: "HomefeedControlPageDesktop" */ 'app/www/pages/HomefeedControlPage'),
  name: 'HomefeedControlPageDesktop',
  path: 'app/www/pages/HomefeedControlPage',
});
export const Engagement = getImport({
  loader: () =>
    import(/* webpackChunkName: "EngagementPageDesktop" */ 'app/www/pages/EngagementPage'),
  name: 'EngagementPageDesktop',
  path: 'app/www/pages/EngagementPage',
});
export const StoryPinsFeedPage = getImport({
  loader: () =>
    import(/* webpackChunkName: "StoryPinsFeedDesktop" */ 'app/www/pages/StoryPinsFeedPage'),
  name: 'StoryPinsFeedDesktop',
  path: 'app/www/pages/StoryPinsFeedPage',
});
export const TopicFeed = getImport({
  loader: () =>
    import(/* webpackChunkName: "TopicFeedPageDesktop" */ 'app/www/pages/TopicFeedPage'),
  name: 'TopicFeedPageDesktop',
  path: 'app/www/pages/TopicFeedPage',
});
export const TopicPage = getImport({
  loader: () => import(/* webpackChunkName: "TopicPageDesktop" */ 'app/www/pages/TopicPage'),
  name: 'TopicPageDesktop',
  path: 'app/www/pages/TopicPage',
});
export const PinDebugTool = getImport({
  loader: () =>
    import(/* webpackChunkName: "PinDebugToolDesktop" */ 'app/www/pages/PinDebugToolPage'),
  name: 'PinDebugToolDesktop',
  path: 'app/www/pages/PinDebugToolPage',
});
export const TrademarkForm = getImport({
  loader: () =>
    import(/* webpackChunkName: "TrademarkFormDesktop" */ 'app/www/pages/TrademarkForm'),
  name: 'TrademarkFormDesktop',
  path: 'app/www/pages/TrademarkForm',
});
export const TrademarkFormSelector = getImport({
  loader: () =>
    import(/* webpackChunkName: "TrademarkFormSelectorDesktop" */ 'app/www/pages/TrademarkFormSelector'),
  name: 'TrademarkFormSelectorDesktop',
  path: 'app/www/pages/TrademarkFormSelector',
});
export const UserBoards = getImport({
  loader: () =>
    import(/* webpackChunkName: "ProfileBoardsPageContainerDesktop" */ 'app/common/react/components/profile/ProfileBoards/ProfileBoardsPageContainer'),
  name: 'ProfileBoardsPageContainerDesktop',
  path: 'app/common/react/components/profile/ProfileBoards/ProfileBoardsPageContainer',
});
export const UserActivities = getImport({
  loader: () =>
    import(/* webpackChunkName: "ProfileActivitiesContainerDesktop" */ 'app/common/react/components/profile/ProfileActivities/ProfileActivitiesContainer'),
  name: 'ProfileActivitiesContainerDesktop',
  path: 'app/common/react/components/profile/ProfileActivities/ProfileActivitiesContainer',
});
export const UserFollowers = getImport({
  loader: () =>
    import(/* webpackChunkName: "ProfileFollowersContainerDesktop" */ 'app/common/react/components/profile/ProfileFollowers/ProfileFollowersContainer'),
  name: 'ProfileFollowersContainerDesktop',
  path: 'app/common/react/components/profile/ProfileFollowers/ProfileFollowersContainer',
});
export const UserFollowing = getImport({
  loader: () =>
    import(/* webpackChunkName: "ProfileFollowingContainerDesktop" */ 'app/common/react/components/profile/ProfileFollowing/ProfileFollowingContainer'),
  name: 'ProfileFollowingContainerDesktop',
  path: 'app/common/react/components/profile/ProfileFollowing/ProfileFollowingContainer',
});
export const UserDidIt = getImport({
  loader: () =>
    import(/* webpackChunkName: "DidItProfileFeedContainerDesktop" */ 'app/common/react/components/do/aggregated-pins/did-it/DidItProfileFeed/DidItProfileFeedContainer'),
  name: 'DidItProfileFeedContainerDesktop',
  path:
    'app/common/react/components/do/aggregated-pins/did-it/DidItProfileFeed/DidItProfileFeedContainer',
});
export const UserOverview = getImport({
  loader: () =>
    import(/* webpackChunkName: "ProfileOverviewContainerDesktop" */ 'app/common/react/components/profile/ProfileOverview/ProfileOverviewContainer'),
  name: 'ProfileOverviewContainerDesktop',
  path: 'app/common/react/components/profile/ProfileOverview/ProfileOverviewContainer',
});
export const UserPins = getImport({
  loader: () =>
    import(/* webpackChunkName: "UserProfilePinGridContainerDesktop" */ 'app/common/react/components/profile/UserProfilePinGrid/UserProfilePinGridContainer'),
  name: 'UserProfilePinGridContainerDesktop',
  path: 'app/common/react/components/profile/UserProfilePinGrid/UserProfilePinGridContainer',
});
export const UserStoreFrontProductGroups = getImport({
  loader: () =>
    import(/* webpackChunkName: "ProfileStoreFrontProductGroupsDesktop" */ 'app/common/react/components/profile/storefront/ProfileProductGroups/ProfileProductGroupsContainer'),
  name: 'ProfileStoreFrontProductGroupsDesktop',
  path:
    'app/common/react/components/profile/storefront/ProfileProductGroups/ProfileProductGroupsContainer',
});
export const UserStoreFrontProductPins = getImport({
  loader: () =>
    import(/* webpackChunkName: "ProfileStoreFrontProductPinsDesktop" */ 'app/common/react/components/profile/storefront/ProfileProductPins/ProfileProductPinsContainer'),
  name: 'ProfileStoreFrontProductPinsDesktop',
  path:
    'app/common/react/components/profile/storefront/ProfileProductPins/ProfileProductPinsContainer',
});
export const UserVideoPins = getImport({
  loader: () =>
    import(/* webpackChunkName: "ProfileVideoPinsContainerDesktop" */ 'app/common/react/components/profile/ProfileVideoPins/ProfileVideoPinsContainer'),
  name: 'ProfileVideoPinsContainerDesktop',
  path: 'app/common/react/components/profile/ProfileVideoPins/ProfileVideoPinsContainer',
});
export const UserSettings = getImport({
  loader: () =>
    import(/* webpackChunkName: "UserSettingsPageDesktop" */ 'app/www/pages/UserSettingsPage'),
  name: 'UserSettingsPageDesktop',
  path: 'app/www/pages/UserSettingsPage',
});
// Note: Yes, the following 8 imports are all UserSettingsPage
// this is an alternative approach to handle the limitations of
// the koa server
export const EditProfile = getImport({
  loader: () =>
    import(/* webpackChunkName: "UserSettingsPageDesktop" */ 'app/www/pages/UserSettingsPage'),
  name: 'UserSettingsPageDesktop',
  path: 'app/www/pages/UserSettingsPage',
});
export const AccountSettings = getImport({
  loader: () =>
    import(/* webpackChunkName: "UserSettingsPageDesktop" */ 'app/www/pages/UserSettingsPage'),
  name: 'UserSettingsPageDesktop',
  path: 'app/www/pages/UserSettingsPage',
});
export const Claim = getImport({
  loader: () =>
    import(/* webpackChunkName: "UserSettingsPageDesktop" */ 'app/www/pages/UserSettingsPage'),
  name: 'UserSettingsPageDesktop',
  path: 'app/www/pages/UserSettingsPage',
});
export const BulkCreatePins = getImport({
  loader: () =>
    import(/* webpackChunkName: "UserSettingsPageDesktop" */ 'app/www/pages/UserSettingsPage'),
  name: 'UserSettingsPageDesktop',
  path: 'app/www/pages/UserSettingsPage',
});
export const Notifications = getImport({
  loader: () =>
    import(/* webpackChunkName: "UserSettingsPageDesktop" */ 'app/www/pages/UserSettingsPage'),
  name: 'UserSettingsPageDesktop',
  path: 'app/www/pages/UserSettingsPage',
});
export const Privacy = getImport({
  loader: () =>
    import(/* webpackChunkName: "UserSettingsPageDesktop" */ 'app/www/pages/UserSettingsPage'),
  name: 'UserSettingsPageDesktop',
  path: 'app/www/pages/UserSettingsPage',
});
export const Security = getImport({
  loader: () =>
    import(/* webpackChunkName: "UserSettingsPageDesktop" */ 'app/www/pages/UserSettingsPage'),
  name: 'UserSettingsPageDesktop',
  path: 'app/www/pages/UserSettingsPage',
});
export const SettingsApps = getImport({
  loader: () =>
    import(/* webpackChunkName: "UserSettingsPageDesktop" */ 'app/www/pages/UserSettingsPage'),
  name: 'UserSettingsPageDesktop',
  path: 'app/www/pages/UserSettingsPage',
});
export const UserStoryPins = getImport({
  loader: () =>
    import(/* webpackChunkName: "ProfileStoryPinsContainerDesktop" */ 'app/common/react/components/profile/ProfileStoryPins/ProfileStoryPinsContainer'),
  name: 'ProfileStoryPinsContainerDesktop',
  path: 'app/common/react/components/profile/ProfileStoryPins/ProfileStoryPinsContainer',
});
export const UserTopics = getImport({
  loader: () =>
    import(/* webpackChunkName: "ProfileTopicsDesktop" */ 'app/common/react/components/profile/ProfileTopics/ProfileTopics'),
  name: 'ProfileTopicsDesktop',
  path: 'app/common/react/components/profile/ProfileTopics/ProfileTopics',
});
export const PinAnalytics = getImport({
  loader: () =>
    import(/* webpackChunkName: "PinAnalyticsPageDesktop" */ 'app/www/pages/PinAnalyticsPage'),
  name: 'PinAnalyticsPageDesktop',
  path: 'app/www/Pages/PinAnalyticsPage',
});
export const PinSavedBoards = getImport({
  loader: () =>
    import(/* webpackChunkName: "PinSavedBoardsPageDesktop" */ 'app/www/pages/PinSavedBoardsPage'),
  name: 'PinSavedBoardsPageDesktop',
  path: 'app/www/Pages/PinSavedBoardsPage',
});
export const TakedownForm = getImport({
  loader: () => import(/* webpackChunkName: "TakedownFormDesktop" */ 'app/www/pages/TakedownForm'),
  name: 'TakedownFormDesktop',
  path: 'app/www/pages/TakedownForm',
});
export const ParentalConsentConfirmation = getImport({
  loader: () =>
    import(/* webpackChunkName: "ParentalConsentConfirmationPageDesktop" */ 'app/www/pages/ParentalConsentConfirmationPage'),
  name: 'ParentalConsentConfirmationPageDesktop',
  path: 'app/www/pages/ParentalConsentConfirmationPage',
});
export const LaunchpadPage = getImport({
  loader: () => import(/* webpackChunkName: "LaunchpadPage" */ 'app/www/pages/LaunchpadPage'),
  name: 'LaunchpadPage',
  path: 'app/www/pages/LaunchpadPage',
});
